<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1200"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon color="red">
              mdi-account-clock
            </v-icon>
          </v-btn>
        </template>
        <span>Part-timer's Salary</span>
      </v-tooltip>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Part-timer's Salary"
      text="The list provided here are the employees that have daily salary type"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-card class="pa-4 elevation-5">
                <v-text-field
                  v-model="searchInput"
                  placeholder="Filter employee by name"
                  append-icon="search"
                  label="Search Employee"
                  hide-no-data
                  hide-selected
                />
     
                <v-data-table
                  v-model="selectedEmployees"
                  v-validate="'required'"
                  dense
                  :loading="tableLoading"
                  :headers="headers"
                  :items="filteredEmployees"
                  item-key="company_employee_uid"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-value="company_employee_uid"
                  class="elevation-1 mb-3"
                  height="272px"
                >
                  <template v-slot:item.name="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          :color="item.payroll_cycle_employees.length > 0 ? 'green' : 'red'"
                          small
                          v-on="on"
                        >
                          {{ item.payroll_cycle_employees.length > 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                      </template>
                      {{ item.payroll_cycle_employees.length > 0 ? 'Added to payroll' : 'Pending' }}
                    </v-tooltip>
                    {{ item.employee.person.name }}
                  </template>
                  <template v-slot:item.salary="{ item }">
                    {{ item.payroll_cycle_part_time_employee_salaries[0] ? currencyFormatting(item.payroll_cycle_part_time_employee_salaries[0].amount) : currencyFormatting(item.company_employee_salaries[0].amount) }}
                  </template>
                  <template v-slot:item.days="{ item }">
                    {{ item.payroll_cycle_part_time_employee_salaries[0] ? item.payroll_cycle_part_time_employee_salaries[0].unit : '' }}
                  </template>
                  <template v-slot:item.total_salary="{ item }">
                    {{ item.payroll_cycle_part_time_employee_salaries[0] ? currencyFormatting(item.payroll_cycle_part_time_employee_salaries[0].amount * item.payroll_cycle_part_time_employee_salaries[0].unit) : '' }}
                  </template>
                  <template v-slot:item.action="{ item }">
                    <payroll-payroll-period-dialog-edit-part-timer-salary
                      v-if="item.payroll_cycle_part_time_employee_salaries[0] && payrollCycleTransaction.status != 'CLOSED'"
                      :payroll-period="payrollPeriod"
                      :salary="item.payroll_cycle_part_time_employee_salaries[0]"
                      @updated="loadData"
                    />
                    <payroll-payroll-period-dialog-add-part-timer-salary
                      v-if="item.payroll_cycle_part_time_employee_salaries.length <= 0 && payrollCycleTransaction.status != 'CLOSED'"
                      :company-employee-uid="item.company_employee_uid"
                      :payroll-cycle-transaction="payrollCycleTransaction"
                      :payroll-period="payrollPeriod"
                      :salary="item.company_employee_salaries[0].amount"
                      @updated="loadData"
                    />
                  </template>
                </v-data-table>

                <v-card-actions style="right: 0px;">
                  <v-spacer />
                  <v-btn
                    :disabled="progressing"
                    text
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      PayrollPayrollPeriodDialogAddPartTimerSalary: () => import('@/components/hris/payroll/payroll-period/DialogAddPartTimerSalary'),
      PayrollPayrollPeriodDialogEditPartTimerSalary: () => import('@/components/hris/payroll/payroll-period/DialogEditPartTimerSalary'),
    },
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollPeriod: {
        type: Object,
        required: true,
      },
      payrollCycleTransaction: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        employees: [],
        tableLoading: false,
        searchInput: '',
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Company',
            align: 'left',
            sortable: false,
            value: 'company.name',
          },
          {
            text: 'Salary (RM)',
            align: 'right',
            sortable: false,
            value: 'salary',
          },
          {
            text: 'Days',
            align: 'right',
            sortable: false,
            value: 'days',
          },
          {
            text: 'Total Salary (RM)',
            align: 'right',
            sortable: false,
            value: 'total_salary',
          },
          {
            text: '',
            align: 'right',
            sortable: false,
            value: 'action',
          },
        ],
        selectedEmployees: [],
      }
    },
    computed: {
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        return this.employees.filter(function (employee) {
          return ((employee.employee.person || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()

        this.tableLoading = true
        
        this.loadData()
      },
    },
    
    methods: {
      loadData () {
        this.$api.payrollCyclePartTimeEmployeeSalaries().list(this.payrollCycleTransaction.id)
          .then(res => {
            this.employees = _.orderBy(res.data, ['employee.person.name', 'company.name'], ['asc', 'asc'])

            this.tableLoading = false
          })
      },
      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)
            this.$api.payrollCycleTransactions().syncAndCompute(this.payrollCycleTransaction.id, this.prepareFormData())
              .then(res => {
                this.$emit('created')
                this.$snack({ message: res.data.status })

                this.setProgressing(false)
                this.dialog = false
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.setProgressing(false)
              })
          })
      },
      prepareFormData () {
        return {
          company_employees: this.selectedEmployees.map(emp => emp.company_employee_uid),
          status: this.payrollCycleTransaction.status,
        }
      },
      setProgressing (status) {
        this.progressing = status
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
